/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/appCardList.config.json';
import axios from 'axios';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { GET_SUPPLY_CHAIN_TEMP } from '../graphql';
import { VApplication } from '@/application';
import { BreadcrumbService } from '../../../../services/breadcrumbService';

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export interface IGetHolderGroupProps {
  offset?: number;
  size?: number;
  where?: any;
}

export interface IAppCardListMethods extends IPluginMethodMap {
  getAppCardListProps(args: any): Promise<any>;
}
const getBreadcrumbService = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.BreadcrumbService') as BreadcrumbService;
};

export class AppCardListService implements IAgentPlugin {
  readonly methods: IAppCardListMethods;

  constructor() {
    this.methods = {
      getAppCardListProps: this.getAppCardListProps.bind(this),
    };
  }

  async getAppCardListProps(args: any) {
    const srv = getBreadcrumbService();
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient('graphql-gateway');
    console.log(`getApp card list`, args);
    try {
      if (client) {
        const res = await client.query({
          query: GET_SUPPLY_CHAIN_TEMP,
          variables: {
            input: {
              skip: args?.offset ?? 0,
              limit: args?.size ?? 10,
              where: {
                org: {
                  id: '9b89e157-c014-42c6-8ce2-929f48edb5bc',
                },
              },
              options: {
                sort: [
                  {
                    createdAt: 'DESC',
                  },
                ],
              },
              stepsOptions2: {
                sort: [
                  {
                    orderedId: 'ASC',
                  },
                ],
              },
            },
          },
          fetchPolicy: 'network-only',
        });
        if (res?.data?.supplyChainTemplates) {
          let _templateData = this.formatHolderGroup(
            res?.data?.supplyChainTemplates
          );
          return {
            appCardList: _templateData,
            isEmpty: res?.data?.supplyChainTemplates?.data?.length <= 0,
            activePage: res?.data?.supplyChainTemplates?.currentPage,
            pageSize: res?.data?.supplyChainTemplates?.pageSize,
            totalCount: res?.data?.supplyChainTemplates?.totalCount,
            totalPages: res?.data?.supplyChainTemplates?.totalPages,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
    // return {
    //   config: { ...config, ...(breadcrumbItems || {}) },
    // };
    // return { ...(config || {}) };
  }

  private formatHolderGroup(data: any) {
    console.log('formatHolderGroup =>', data);
    let _appCard = data.map((item: any) => {
      return {
        ...item,
        appCardId: item?.id,
        appCardImage: item?.icon,
        appCardTitle: item?.name,
        appCardDescription: item?.description,
      };
    });

    return _appCard;
  }
}
